import { z } from 'zod';
import { attachmentSchema } from '../../../attachments/index.js';
import { positiveIntSchema } from '../../../shared/index.js';
export const PUBLIC_COMMENT_MAX_LENGTH = 10_000;
export const publicCommentCreateBodySchema = z.object({
    agendaSectionId: positiveIntSchema,
    legislativeItemId: positiveIntSchema.optional(),
    comment: z.string().trim().min(1, 'Comment is required').max(PUBLIC_COMMENT_MAX_LENGTH),
    attachment: attachmentSchema.optional(),
});
